const SHIPPING_ALERTS_REFRESH_EVENT = 'crm-shipping-alerts-refresh';

/** Notify the dashboard bell to reload urgent unshipped / CS alerts. */
export function notifyShippingAlertsRefresh() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SHIPPING_ALERTS_REFRESH_EVENT));
}

export function subscribeShippingAlertsRefresh(callback) {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const handler = () => {
    callback();
  };

  window.addEventListener(SHIPPING_ALERTS_REFRESH_EVENT, handler);
  return () => {
    window.removeEventListener(SHIPPING_ALERTS_REFRESH_EVENT, handler);
  };
}
